import EligibiltyCriteria from "../Specialization/EligibiltyCriteria/EligibiltyCriteria";
import ProgrameHighlight from "../Specialization/ProgrameHighlight/ProgrameHighlight";
import SpecializationLeadership from "../Specialization/SpecializationLeadership/SpecializationLeadership";
import Admission_Process from "../Specialization/admission-process/Admission_Process";
import Dpu_Exciting_Opportunity from "../Specialization/dpu_exciting_opportunity/Dpu_Exciting_Opportunity";
import Dpu_Learn_Ai_Tool_Swiper from "../Specialization/dpu_learn_ai_tool_swiper/Dpu_Learn_Ai_Tool_Swiper";
import Dpu_Mca_Alumini from "../Specialization/dpu_mca_alumini/Dpu_Mca_Alumini";
import Dpu_Mca_Certification from "../Specialization/dpu_mca_certification/Dpu_Mca_Certification";
import Dpu_Mca_Faq from "../Specialization/dpu_mca_faq/Dpu_Mca_Faq";
import Dpu_Mca_Feature from "../Specialization/dpu_mca_feature/Dpu_Mca_Feature";
import Dpu_Mca_Highlight from "../Specialization/dpu_mca_highlight/Dpu_Mca_Highlight";
import Dpu_Mcs_Recognization from "../Specialization/dpu_mcs_recognization/Dpu_Mcs_Recognization";
import MCA_Program_Structure from "../Specialization/mca-program-structure/MCA_Program_Structure";
import Specialization_Banner from "../Specialization/specialization-banner/Specialization_Banner";
import Specialization_Fee_Curriculum from "../Specialization/specialization-fee-curriculum/Specialization_Fee_Curriculum";
import Speciallization_Key_Feature from "../Specialization/speciallization_key_feature/Speciallization_Key_Feature";
import FinalCTABanner from "../common_components/finalCTABanner/FinalCTABanner";

const Specializations = () => {
  return (
    <>
      <Specialization_Banner />
      <Dpu_Mca_Feature />
      <SpecializationLeadership />
      <Dpu_Mca_Highlight />
      <Dpu_Mcs_Recognization />
      <Specialization_Fee_Curriculum />
      <MCA_Program_Structure />
      <Speciallization_Key_Feature />
      <EligibiltyCriteria />
      <ProgrameHighlight />
      <Admission_Process />
      <Dpu_Learn_Ai_Tool_Swiper />
      <Dpu_Mca_Certification />
      <Dpu_Mca_Alumini />
      <Dpu_Exciting_Opportunity />
      <Dpu_Mca_Faq />
      <FinalCTABanner />
    </>
  );
};

export default Specializations;
